<template>
  <el-main>
    <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <!-- 基本信息 -->
      <el-card class="box-card" shadow="always">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <div class="card_content_box">
          <el-form-item v-if="is_supplier">
            <template #label>
              <div class="is_mandatory">
                <div>销售模式</div>
              </div>
            </template>
            <el-select v-model="supplier_form.sales_model" filterable placeholder="请选择" :disabled="is_look_info">
              <el-option v-for="type in sale_model_list" :key="type.dict_value" :label="type.description"
                :value="type.dict_value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div class="is_mandatory">
                <div>状态</div>
              </div>
            </template>
            <el-select v-model="custom_form.status" filterable placeholder="请选择" :disabled="is_look_info">
              <el-option v-for="type in car_type_list" :key="type.dict_value" :label="type.description"
                :value="type.dict_value"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-card>
      <!-- 车辆参数 -->
      <el-card class="box-card" shadow="always">
        <div slot="header" class="clearfix">
          <span>车辆参数</span>
        </div>
        <div class="card_content_box">
          <el-form-item label="车辆编号">
            <el-input placeholder="请输入" v-model="custom_form.asset_code" :disabled="is_look_info"></el-input>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div class="is_mandatory">
                <div>车辆类别</div>
              </div>
            </template>
            <el-select v-model="supplier_form.cate_id" filterable placeholder="请选择" :disabled="is_look_info">
              <el-option v-for="item in cate_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div class="is_mandatory">
                <div>产品分类</div>
              </div>
            </template>
            <el-select disabled v-model="custom_form.new_category_parent_id" @change="v3FilterCategorysChange"
              filterable placeholder="请选择">
              <el-option v-for="item in categorysV3" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div class="is_mandatory">
                <div>产品子类</div>
              </div>
            </template>
            <el-select disabled v-model="custom_form.new_category_id" filterable placeholder="请选择">
              <el-option v-for="item in second_category" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- @change="getFormInfo() -->
          <!-- <el-form-item>
            <template #label>
              <div class="is_mandatory">
                <div>车辆类型</div>
              </div>
            </template>
            <el-select v-model="c_id" filterable placeholder="请选择" :disabled="is_look_info">
              <el-option v-for="item in car_category_list" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item v-for="params in c_form_info.category_attribute_list" :key="params.attribute_id">
            <template #label>
              <div :class="params.is_mandatory == 'Y' ? 'is_mandatory' : ''">
                <div>{{ params.attribute_info.attribute_name }}</div>
              </div>
            </template>
            <el-input v-if="params.attribute_info.assignment_type === 'V'" v-model="params.value" placeholder="请填写"
              :disabled="is_look_info"></el-input>
            <el-select v-model="params.value.id"
              v-if="params.attribute_info.assignment_type === 'R' || params.attribute_info.assignment_type === 'C'"
              filterable :multiple="params.attribute_info.assignment_type === 'R' ? false : true" placeholder="请选择"
              clearable :disabled="is_look_info">
              <el-option v-for="content in params.child_category_attribute_value" :key="content.id"
                :label="content.option_name" :value="content.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div class="is_mandatory">
                <div>车辆地址</div>
              </div>
            </template>
            <div class="address_box">
              <el-input disabled placeholder="请定位" v-model="custom_form.location.address"></el-input>
              <el-button :disabled="is_look_info" type="primary" @click="() => (dialogMap = true)">定位</el-button>
            </div>
          </el-form-item>
        </div>
      </el-card>
      <!-- 车辆价格 v-if="is_supplier" -->
      <el-card class="box-card" shadow="always">
        <div slot="header" class="clearfix">
          <span>车辆价格</span>
        </div>
        <div class="card_content_box">
          <el-form-item>
            <template #label>
              <div class="is_mandatory">
                <div>结算价</div>
              </div>
            </template>
            <el-input placeholder="请输入结算价" v-model.number="custom_form.price_config.settlement_price" type="number"
              :min="0" :step="0.01"  :disabled="is_look_info"></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <template #label>
              <div class="">
                <div>零售价</div>
              </div>
            </template>
            <el-input v-model.number="custom_form.price_config.price" type="number" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div class="">
                <div>会员价</div>
              </div>
            </template>
            <el-input v-model.number="custom_form.price_config.vip_price" type="number" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div class="">
                <div>最终结算价</div>
              </div>
            </template>
            <el-input v-model.number="custom_form.price_config.last_settlement_price" type="number" disabled></el-input>
          </el-form-item> -->
          <!-- <el-form-item>
            <template #label>
              <div class="">
                <div>会员价</div>
              </div>
            </template>
            <el-input placeholder="请输入会员价(同行价)" v-model.number="supplier_form.price_config.original_price" type="number" :min="0"
              :step="0.01" @input="(val) => handlePriceInput(val, 'price')" :disabled="is_look_info"></el-input>
          </el-form-item> -->
        </div>
      </el-card>
      <!-- 商家版车辆价格 -->
      <!-- <el-card class="box-card" shadow="always" v-else>
        <div slot="header" class="clearfix">
          <span>车辆价格</span>
        </div>
        <div class="card_content_box">
          <el-form-item v-if="custom_form.status === 'ONRENT'">
            <template #label>
              <div class="is_mandatory">
                <div>租期</div>
              </div>
            </template>
            <el-date-picker v-model="custom_form.rent_config.time" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :disabled="is_look_info"></el-date-picker>
          </el-form-item>
          <el-form-item label="预售时间" v-if="custom_form.status === 'ONLINESALL'">
            <template #label>
              <div class="is_mandatory">
                <div>预售时间</div>
              </div>
            </template>
            <el-date-picker v-model="custom_form.line_sell.start_time" type="date" placeholder="选择日期"
              :disabled="is_look_info"></el-date-picker>
          </el-form-item>
          <el-form-item label="同行售价">
            <el-input v-model="custom_form.price_config.original_price" placeholder="请填写"
              :disabled="is_look_info"></el-input>
          </el-form-item>
          <el-form-item label="零售价">
            <el-input v-model="custom_form.price_config.price" placeholder="请填写"></el-input>
          </el-form-item>
          <div class="el-form-item" v-if="custom_form.status === 'ONRENT' || custom_form.status === 'ONLINESALL'"></div>
          <el-form-item label="面议">
            <el-switch v-model="custom_form.price_config.is_mianyi" active-color="#13ce66" inactive-color="#ff4949"
              :active-value="1" :inactive-value="0" :disabled="is_look_info"></el-switch>
          </el-form-item>
          <el-form-item label="同行租价" v-if="!custom_form.price_config.is_mianyi">
            <el-input v-model="custom_form.price_config.peer_price" placeholder="请填写"
              :disabled="is_look_info"></el-input>
          </el-form-item>
          <el-form-item label="终端租价" v-if="!custom_form.price_config.is_mianyi">
            <el-input v-model="custom_form.price_config.rent_price" placeholder="请填写"
              :disabled="is_look_info"></el-input>
          </el-form-item>
        </div>
      </el-card> -->
      <!-- 车辆图片 -->
      <el-card class="box-card" shadow="always">
        <div slot="header" class="clearfix">
          <span>车辆素材</span>
        </div>
        <div class="">
          <el-form-item style="width: 100%">
            <template #label>
              <div class="is_mandatory">
                <div>车辆图片</div>
              </div>
            </template>
            <ReadyUploadSource @getSource="getCarImg" @changeOrder="changeOrder" @removeThis="removeImageThis"
              :isMany="true" :manyPath="custom_form.source_list.images_list" :isManyMax="9" :disabled="is_look_info">
            </ReadyUploadSource>
          </el-form-item>
          <el-form-item label="车辆视频" style="width: 100%; margin-left: 0">
            <ReadyUploadSource @getSource="getVideoSource" @removeThis="removeVideoThis"
              :path="custom_form.source_list.video_url" type="video" :disabled="is_look_info"></ReadyUploadSource>
          </el-form-item>
        </div>
      </el-card>
      <!-- 渲染组件参数 -->
      <el-card class="box-card" shadow="always" v-for="component in c_form_info.category_component" :key="component.id">
        <div slot="header" class="clearfix">
          <span>{{ component.name }}</span>
        </div>
        <div class="card_content_box">
          <el-form-item v-for="params in component.component_attribute" :key="params.attribute_id">
            <template #label>
              <div :class="params.is_mandatory == 'Y' ? 'is_mandatory' : ''">
                <div>{{ params.attribute_info.attribute_name }}</div>
              </div>
            </template>
            <el-input v-model="params.value" v-if="params.attribute_info.assignment_type === 'V'" placeholder="请填写"
              :disabled="is_look_info"></el-input>
            <el-select v-model="params.value.id"
              v-if="params.attribute_info.assignment_type === 'R' || params.attribute_info.assignment_type === 'C'"
              filterable :multiple="params.attribute_info.assignment_type === 'R' ? false : true" placeholder="请选择"
              clearable :disabled="is_look_info">
              <el-option v-for="content in params.attribute_info.child_component_attribute_value" :key="content.id"
                :label="content.option_name" :value="content.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-card>
      <!-- 车辆保险时间 -->
      <el-card class="box-card" shadow="always">
        <div slot="header" class="clearfix">
          <span>保险资料</span>
        </div>
        <div class="card_content_box">
          <el-form-item label="车辆保险到期日" label-width="120px">
            <el-date-picker v-model="custom_form.insurance.insurance_expired" type="date" placeholder="选择日期"
              :disabled="is_look_info"></el-date-picker>
          </el-form-item>
          <el-form-item label="年检到期日">
            <el-date-picker v-model="custom_form.insurance.annual_expired" type="date" placeholder="选择日期"
              :disabled="is_look_info"></el-date-picker>
          </el-form-item>
        </div>
      </el-card>
    </el-form>

    <PositionDialog @close="dialogMap = false" :show="dialogMap" @confirm="confirmCoordinate"></PositionDialog>

    <Preservation v-if="!is_look_info" @preservation="addCarBtn"></Preservation>
  </el-main>
</template>

<script>
import Preservation from '@/components/preservation.vue';
import ReadyUploadSource from '@/components/readyUploadSource.vue';
import InfiniteScroll from '@/directives/infiniteScroll.js';
import PositionDialog from '@/components/positionDialog.vue';
import { dealPriceCalc } from '@/util/util.js'

export default {
  directives: {
    more: InfiniteScroll,
    PositionDialog,
  },
  components: {
    Preservation,
    ReadyUploadSource,
    PositionDialog,
  },
  computed: {
    is_look_info() {
      return this.$route.path == '/chache/infoCar';
    },
    now_category_name() {
      let c = this.car_category_list.find((i) => i.id == this.c_id);
      return c ? c.name : '';
    },
  },
  data() {
    return {
      c_id: null,
      car_id: null,
      c_form_info: {},
      is_supplier: true,
      dialogMap: false,
      other_status: '',
      custom_form: {
        asset_code: '', // 库存编码
        status: 'ONSHELVE', // 车辆状态
        location: {
          // 车辆地址
          address: '',
          lat: null,
          lng: null,
        },
        insurance: {
          // 保险时间
          insurance_expired: '',
          annual_expired: '',
        },
        rent_config: {
          // 租期时间
          time: [],
        },
        line_sell: {
          // 预售参数
          start_time: null,
          pre_price: '',
        },
        price_config: {
          is_mianyi: false, // 是否可以面议
          price: '', // 客户价
          original_price: '', // 入库价
          peer_price: '', // 同行租金价
          rent_price: '', // 终端租金价,
          // 新版本价格体系
          settlement_price: '',
        },
        source_list: {
          images_list: [], // 车辆图片列表
          cover: '', // 视频封面
          video_url: '', // 视频地址
        },
        new_category_id: '',
        new_category_parent_id: '',
      },
      price_rate: {
        "retail_price_rate": "",
        "member_price_rate": ""
      },
      car_type_list: [],
      add_car_form_mapping: {
        // '6':'asset_code', // 产品型号
        4: 'brand_id', // 整车品牌
        7: 'belong_year', // 出厂年份
        22: 'using_hour', // 车辆小时数
      },
      supplier_form: {
        store_id: '',
        cate_id: '',
        sales_model: '',
        price_config: {
          price: '', // 销售价
          original_price: '', // 会员价
        },
      },
      sale_model_list: [],
      cate_list: [],
      car_category_list: [],
      categorysV3: [],
      second_category: []
    };
  },
  methods: {
    v3FilterCategorysChange() {
      this.custom_form.new_category_id = ''
      this.getV3Categorys(this.custom_form.new_category_parent_id)
    },
    // 获取新车辆分类列表
    getV3Categorys(new_category_id) {
      let obj = {}
      if (new_category_id) {
        obj.new_category_id = new_category_id
        obj.level = 2
      }
      this.$axios.post(this.$api.chache.getNewCategorys, obj).then((res) => {
        if (res.code === 0) {
          if (!new_category_id) {
            this.categorysV3 = res.result.new_category_list.list
            if (this.$route.query.f) {
              this.$set(this.custom_form, 'new_category_id', Number(this.$route.query.n))
              this.$set(this.custom_form, 'new_category_parent_id', Number(this.$route.query.f))
              this.getV3Categorys(this.$route.query.f)
            }
          } else {
            this.second_category = res.result.new_category_list.list
          }
        }
      })
    },
    getFormInfo(inin_car) {
      let car_info_attribute_hash = {};
      let car_info_category_component_hash = {};
      if (this.c_form_info.category_attribute_list) {
        this.c_form_info.category_attribute_list.forEach((i) => {
          car_info_attribute_hash[i.attribute_id] = i.value;
        });
      }
      if (this.c_form_info.category_component) {
        this.c_form_info.category_component.forEach((i) => {
          car_info_category_component_hash[i.component_id] = {};
          i.component_attribute.forEach((j) => {
            car_info_category_component_hash[i.component_id][j.attribute_id] = j.value;
          });
        });
      }
      this.$axios.post(this.$api.chache.category_info, { id: this.c_id }).then((res) => {
        if (res.code == 0) {
          res.result.category_attribute_list.map((i) => {
            let info_hash = car_info_attribute_hash[i.attribute_id];
            if (i.attribute_info.assignment_type == 'V') {
              i.value = info_hash ? info_hash : '';
            } else {
              let is_hash_attr_value = undefined;
              if (info_hash) is_hash_attr_value = i.child_category_attribute_value.find((j) => j.id == info_hash.id);
              i.value = {
                id: is_hash_attr_value ? info_hash.id : null,
                option_name: is_hash_attr_value ? info_hash.option_name : '',
              };
            }
          });
          res.result.category_component.map((i) => {
            i.component_attribute.map((t) => {
              let component_hash = car_info_category_component_hash[i.component_id];
              let info_hash = component_hash ? component_hash[t.attribute_id] : null;
              if (t.attribute_info.assignment_type == 'V') {
                t.value = info_hash ? info_hash : '';
              } else {
                let is_hash_attr_value = undefined;
                if (info_hash) is_hash_attr_value = t.attribute_info.child_component_attribute_value.find((j) => j.id == info_hash.id);
                t.value = {
                  id: is_hash_attr_value ? info_hash.id : null,
                  option_name: is_hash_attr_value ? info_hash.option_name : '',
                };
              }
            });
          });
          this.c_form_info = res.result;
          if (inin_car) this.getCarInfo(inin_car);
        } else {
          this.$message.error(res.msgg);
        }
      });
    },
    // 获取车辆详情
    getCarInfo(inin_car) {
      this.$axios
        .post(this.$api.chache.car_info, {
          id: this.car_id,
        })
        .then((res) => {
          if (res.code == 0) {
            let data = res.result;
            this.other_status = data.status;
            this.custom_form = {
              asset_code: data.asset_code, // 库存编码
              status: data.status || '', // 车辆状态
              location: {
                // 车辆地址
                address: data.location,
                lat: data.lat,
                lng: data.lng,
              },
              insurance: {
                // 保险时间
                insurance_expired: data.insurance_expired ? data.insurance_expired * 1000 : '',
                annual_expired: data.annual_expired ? data.annual_expired * 1000 : '',
              },
              rent_config: {
                // 租期时间
                time: data.status === 'ONRENT' ? [data.start_time * 1000 || null, data.end_time * 1000 || null] : [],
              },
              line_sell: {
                // 预售参数
                start_time: data.status === 'ONLINESALL' ? data.start_time * 1000 : null,
                pre_price: data.status === 'ONLINESALL' ? data.price * 1000 : '',
              },
              source_list: {
                images_list: [], // 车辆图片列表
                cover: data.video_img_url, // 视频封面
                video_url: data.video_url, // 视频地址
              },
              new_category_parent_id: data.new_category_parent_id || '',
              new_category_id: data.new_category_id || ''
            };
            if (data.new_category_parent_id) {
              this.getV3Categorys(data.new_category_parent_id)
            }
            if (!this.is_supplier) {
              this.$set(this.custom_form, 'price_config', {
                settlement_price: parseFloat(res.result.settlement_price) || '',
              })
            }
            if (this.is_supplier) {
              this.supplier_form = {
                store_id: res.result.store_id,
                sales_model: res.result.sales_model,
                price_config: {
                  price: res.result.price, // 销售价
                  original_price: res.result.original_price
                },
              };
            }
            this.supplier_form.cate_id = res.result.item_cate_id || '';
            res.result.item_images.map((item) => {
              this.custom_form.source_list.images_list.push(item.image_url);
            });
            res.result.item_attribute_list.map((item) => {
              let data = this.c_form_info.category_attribute_list.find((i) => i.attribute_id == item.attribute_id);
              if (data.attribute_info.assignment_type == 'V') {
                data.value = item.option_name;
              } else {
                data.value = {
                  id: item.attribute_value_id,
                  option_name: item.option_name,
                };
              }
            });
            res.result.category_component.map((item) => {
              let component = this.c_form_info.category_component.find((i) => i.component_id == item.component_id);
              item.component_attribute.map((attr) => {
                let c_attr = component.component_attribute.find((a) => a.attribute_id == attr.attribute_id);
                if (c_attr.attribute_info.assignment_type == 'V') {
                  c_attr.value = attr.option_name;
                } else {
                  c_attr.value = {
                    id: attr.attribute_value_id,
                    option_name: attr.option_name,
                  };
                }
              });
            });
            if (inin_car) this.getFormInfo();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 获取选中的图片
    getCarImg(val) {
      val.map((img) => {
        this.custom_form.source_list.images_list.push(img.path);
      });
    },
    // 拖动重新赋值车辆图片顺序
    changeOrder(list) {
      this.custom_form.source_list.images_list = list;
    },
    // 移除某张图片
    removeImageThis(index) {
      this.custom_form.source_list.images_list.splice(index, 1);
    },
    //获取视频地址
    getVideoSource(val) {
      this.custom_form.source_list.cover = val.cover;
      this.custom_form.source_list.video_url = val.path;
    },
    //移除视频
    removeVideoThis() {
      this.custom_form.source_list.cover = '';
      this.custom_form.source_list.video_url = '';
    },
    // 获取车辆定位
    confirmCoordinate(info) {
      this.custom_form.location.address = info.district + info.name;
      this.custom_form.location.lng = info.lng;
      this.custom_form.location.lat = info.lat;
      this.dialogMap = false;
    },
    dealParams(status) {
      let obj = {
        asset_code: this.custom_form.asset_code,
        attribute_value_ids: [],
        component_attribute_value_ids: [],
        cate_id: this.supplier_form.cate_id,
        category_id: this.c_id,
        product_name: this.now_category_name,
        product_image_url: this.custom_form.source_list.images_list[0],
        product_image_urls: this.custom_form.source_list.images_list,
        video_url: this.custom_form.source_list.video_url,
        video_img_url: this.custom_form.source_list.cover,
        location: this.custom_form.location.address,
        lat: this.custom_form.location.lat,
        lng: this.custom_form.location.lng,
        status: this.custom_form.status,
        insurance_expired: this.custom_form.insurance.insurance_expired,
        annual_expired: this.custom_form.insurance.annual_expired,
        sales_model: this.supplier_form.sales_model,
        new_category_parent_id: this.custom_form.new_category_parent_id,
        new_category_id: this.custom_form.new_category_id,
        settlement_price: parseFloat(this.custom_form.price_config.settlement_price) || '',
      };
      // if (this.is_supplier) {
      //   obj.price = this.supplier_form.price_config.price;
      //   obj.original_price = this.supplier_form.price_config.original_price
      //   obj.store_id = this.supplier_form.store_id;
      // }

      if (obj.insurance_expired) obj.insurance_expired = Math.floor(obj.insurance_expired.getTime() / 1000);
      if (obj.annual_expired) obj.annual_expired = Math.floor(obj.annual_expired.getTime() / 1000);

      return new Promise(async (resolve, reject) => {
        if (obj.new_category_parent_id && !obj.new_category_id) {
          resolve({ status: -1, msg: `请选择产品分类` });
        }
        // 图片检测
        if (!obj.product_image_urls.length) resolve({ status: -1, msg: `请上传车辆图片` });
        // 状态检测
        if (!obj.status) {
          resolve({ status: -1, msg: `请选择状态` });
        }
        if (!obj.cate_id) {
          resolve({ status: -1, msg: `请选择车辆类别` });
        }
        if (!obj.settlement_price) {
          resolve({ status: -1, msg: `请填写结算价格` });
        }
        // 非供应商车辆检测状态和状态对应数据
        if (!this.is_supplier) {
          if (obj.status == 'ONRENT') {
            obj.start_time = this.custom_form.rent_config.time[0];
            obj.end_time = this.custom_form.rent_config.time[1];
            if (!obj.start_time || !obj.end_time) {
              resolve({
                status: -1,
                msg: `添加已租车辆时请在价格区域选择租赁时间`,
              });
            }
          }
          if (obj.status == 'ONLINESALL') {
            obj.start_time = this.custom_form.line_sell.start_time;
            obj.pre_price = obj.price;
            if (!obj.start_time) {
              resolve({
                status: -1,
                msg: `添加预售车辆时请在价格区域选择预售时间`,
              });
            }
          }
        }
        // 供应商车辆检测状态和状态对应数据
        // if (this.is_supplier) {
        //   if (!obj.sales_model) {
        //     resolve({ status: -1, msg: `请选择销售模式` });
        //   }
        //   if(parseFloat(obj.price) < parseFloat(obj.original_price)){
        //     resolve({ status: -1, msg: `会员价不可大于销售价` });
        //   }
        //   if (!parseFloat(obj.price)) {
        //     if (this.is_supplier) resolve({ status: -1, msg: `请输入销售价` });
        //   }
        // }

        if (obj.start_time) obj.start_time = Math.floor(obj.start_time.getTime() / 1000);
        if (obj.end_time) obj.end_time = Math.floor(obj.end_time.getTime() / 1000);

        for (let i = 0; i < this.c_form_info.category_attribute_list.length; i++) {
          let data = this.c_form_info.category_attribute_list[i];
          // 验证参数非空
          if (data.is_mandatory === 'Y') {
            if (data.attribute_info.assignment_type == 'V' && !data.value) {
              resolve({
                status: -1,
                msg: `请填写${data.attribute_info.attribute_name}`,
              });
              break;
            }
            if (data.attribute_info.assignment_type == 'R' && !data.value.id) {
              resolve({
                status: -1,
                msg: `请选择${data.attribute_info.attribute_name}`,
              });
              break;
            }
          }
          // 拼接名字 品牌+车辆分类+产品型号
          if (data.attribute_info.id == 4) {
            obj.product_name = data.value.option_name + obj.product_name;
          }
          if (data.attribute_info.id == 6) {
            obj.product_name = data.value + obj.product_name;
          }
          // 处理特殊参数
          if (this.add_car_form_mapping[`${data.attribute_info.id}`]) {
            if (data.attribute_info.assignment_type === 'R') {
              if (data.attribute_info.id == 4) obj[this.add_car_form_mapping[`${data.attribute_info.id}`]] = data.value.id;
              else obj[this.add_car_form_mapping[`${data.attribute_info.id}`]] = data.value.option_name;
            }
            if (data.attribute_info.assignment_type === 'V') obj[this.add_car_form_mapping[`${data.attribute_info.id}`]] = data.value;
          }
          let s_obj = {
            attribute_id: null,
            attribute_value_id: null,
          };
          s_obj.attribute_id = data.attribute_id;
          if (data.attribute_info.assignment_type === 'R') {
            s_obj.attribute_value_id = data.value.id;
          }
          if (data.attribute_info.assignment_type === 'V' && data.value) {
            let r = await this.$axios.post(this.$api.chache.params_content_add, {
              attribute_id: data.attribute_id,
              option_name: data.value,
            });
            if (r.code === 0) {
              s_obj.attribute_value_id = r.result;
            } else {
              resolve({ status: -1, msg: r.msg });
            }
          }
          obj.attribute_value_ids.push(s_obj);
        }
        for (let i = 0; i < this.c_form_info.category_component.length; i++) {
          let item = this.c_form_info.category_component[i];
          for (let j = 0; j < item.component_attribute.length; j++) {
            let s_obj = {
              component_id: null,
              attribute_value_id: null,
            };
            s_obj.component_id = item.component_id;
            let c_son = item.component_attribute[j];
            if (c_son.attribute_info.assignment_type === 'R') {
              s_obj.attribute_value_id = c_son.value.id;
            }
            if (c_son.attribute_info.assignment_type === 'V' && c_son.value) {
              let r = await this.$axios.post(this.$api.chache.params_content_add, {
                attribute_id: c_son.attribute_id,
                option_name: c_son.value,
              });
              if (r.code === 0) {
                s_obj.attribute_value_id = r.result;
              } else {
                resolve({ status: -1, msg: r.msg });
              }
            }
            obj.component_attribute_value_ids.push(s_obj);
          }
        }
        resolve({ status: 0, data: obj });
      });
    },
    // 保存车辆
    async addCarBtn() {
      let result = await this.dealParams();
      if (result.status == -1) {
        this.$message.warning(result.msg);
        return;
      }
      let obj = result.data;
      let url = this.$api.chache.car_add;
      if (this.car_id) {
        obj.id = this.car_id;
        url = this.$api.chache.car_edit;
      }
      this.$axios.post(url, obj).then((res) => {
        if (res.code == 0) {
          this.$router.back();
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getCateList() {
      this.$axios
        .post(this.$api.chache.cate_list, {
          is_car: 1,
        })
        .then((res) => {
          if (res.code === 0) {
            this.cate_list = res.result;
          }
        });
    },
    getCarTypeList() {
      this.$axios
        .post(this.$api.chache.category_list, {
          is_add: 1,
        })
        .then((res) => {
          if (res.code === 0) {
            this.car_category_list = res.result.list;
          }
        });
    },
    handlePriceInput(val, key) {
      // 限制为大于0的数字，最多两位小数
      if (val && val > 0) {
        // 移除非数字和小数点字符，然后限制两位小数
        const numStr = String(val).replace(/[^\d.]/g, '');
        const parts = numStr.split('.');
        if (parts.length > 1) {
          parts[1] = parts[1].substring(0, 2);
        }
        const formattedNum = parseFloat(parts.join('.'));
        if (!isNaN(formattedNum) && formattedNum > 0) {
          this.$nextTick(() => {
            this.$set(this.custom_form.price_config, key, formattedNum);
          });
        }
      }
    }
  },
  created() {
    let s_type = this.$store.state.user.store_type || localStorage.getItem('s_type');
    this.is_supplier = this.$store.state.user.supplier_type_list.findIndex((i) => i == s_type) != -1;

    if (!this.$route.query.c) this.$router.back();
    this.c_id = this.$route.query.c;
    if (this.$route.query.car) {
      this.car_id = this.$route.query.car;
      this.getFormInfo(1);
    }
    if (this.c_id && !this.$route.query.car) this.getFormInfo();
    this.$store.dispatch('basic/getPayHash', { type: 'SALESMODEL' }).then((res) => {
      this.sale_model_list = res;
    });
    this.$store.dispatch('basic/getPayHash', { type: 'VEHICLESTATE' }).then((res) => {
      this.car_type_list = res;
    });
    this.getCateList();
    this.getCarTypeList();
    this.getV3Categorys();
  },
};
</script>

<style lang="less" scoped>
.el-main {
  padding: 0;
  padding-bottom: 50px;
  min-height: 100%;

  .el-card {
    margin-bottom: 16px;
  }

  .is_mandatory {
    display: flex;
    justify-content: flex-end;
    & > div {
      width: fit-content;
      position: relative;
      &::after {
        content: '*';
        color: red;
        display: block;
        position: absolute;
        top: 0px;
        left: -8px;
      }
    }
  }

  .card_content_box {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    .el-form-item {
      margin-bottom: 0 !important;
      .el-input,
      .el-select {
        width: 90%;
      }

      .address_box {
        display: flex;
      }
    }
  }
}
.line_area {
  display: flex;
  flex-direction: column;
  .el-input {
    margin-top: 6px;
  }
  .form_tip {
    margin-top: 6px;
    line-height: 24px;
    font-size: 12px;
    color: #ccc;
  }
}
</style>
